import React from 'react';
import _ from 'lodash';
import { priceFormatterV3 } from '../../../settings/themeSettings';
import SectionHeader from '../components/SectionHeader';

const SyntheseActivite = ({ dashboardData, journalVenteData }) => {
    const totalCATourisme = Number(dashboardData?.totalPaiementTourisme) || 0;

    // Utiliser les données du journal de vente pour la billetterie
    const billetterieJournal = journalVenteData || [];
    const billetterieFiltered = billetterieJournal.filter(item =>
        item.type_transaction === 'billetterie' ||
        item.service === 'billetterie' ||
        !item.type_transaction
    );
    const dataToUse = billetterieFiltered.length > 0 ? billetterieFiltered : billetterieJournal;

    const totalCABilletterie = Number(_.sumBy(dataToUse, (item) => Number(item.montant_vente) || Number(item.tarif) || 0)) || 0;
    const totalCAGlobal = totalCATourisme + totalCABilletterie;

    const totalDeboursTourisme = Number(dashboardData?.totalFraisTourisme) || 0;
    const totalDeboursBilletterie = Number(_.sumBy(dataToUse, (item) => Number(item.montant_achat) || Number(item.debours) || 0)) || 0;
    const totalDeboursGlobal = totalDeboursTourisme + totalDeboursBilletterie;

    const margeTourisme = totalCATourisme - totalDeboursTourisme;
    const margeBilletterie = totalCABilletterie - totalDeboursBilletterie;
    const margeGlobale = margeTourisme + margeBilletterie;

    const pourcentageTourisme = totalCAGlobal > 0 ? ((totalCATourisme / totalCAGlobal) * 100).toFixed(1) : 0;
    const pourcentageBilletterie = totalCAGlobal > 0 ? ((totalCABilletterie / totalCAGlobal) * 100).toFixed(1) : 0;
    const pourcentageMargeTourisme = totalCATourisme > 0 ? ((margeTourisme / totalCATourisme) * 100).toFixed(1) : 0;
    const pourcentageMargeBilletterie = totalCABilletterie > 0 ? ((margeBilletterie / totalCABilletterie) * 100).toFixed(1) : 0;
    const pourcentageMargeGlobale = totalCAGlobal > 0 ? ((margeGlobale / totalCAGlobal) * 100).toFixed(1) : 0;

    return (
        <div className="analysis-section">
            <SectionHeader
                title="📊 SYNTHESE ACTIVITE GLOBALE"
                pdfData={[
                    { metrique: "CA Tourisme", montant: totalCATourisme, pourcentage: `${pourcentageTourisme}%`, marge: margeTourisme },
                    { metrique: "CA Billetterie", montant: totalCABilletterie, pourcentage: `${pourcentageBilletterie}%`, marge: margeBilletterie },
                    { metrique: "Total Global", montant: totalCAGlobal, pourcentage: "100.0%", marge: margeGlobale }
                ]}
                pdfFilename="synthese-activite-globale.pdf"
                pdfTitle="Synthèse Activité Globale"
                pdfTableHeaders={["Activité", "CA", "% du CA Total", "Marge"]}
            />

            <div className="table-container-prof">
                <div className="table-title-prof">SYNTHESE GENERALE DES ACTIVITES</div>
                <table className="professional-table">
                    <thead>
                        <tr>
                            <th className="text-left">ACTIVITE</th>
                            <th className="text-right">CHIFFRE D'AFFAIRES</th>
                            <th className="text-right">DEBOURS</th>
                            <th className="text-right">MARGE</th>
                            <th className="text-right">% MARGE</th>
                            <th className="text-right">% DU CA GLOBAL</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td className="text-left"><strong>TOURISME</strong></td>
                            <td className="currency-cell">{priceFormatterV3(totalCATourisme)}</td>
                            <td className="currency-cell">{priceFormatterV3(totalDeboursTourisme)}</td>
                            <td className="currency-cell">{priceFormatterV3(margeTourisme)}</td>
                            <td className="percentage-cell">{pourcentageMargeTourisme}%</td>
                            <td className="percentage-cell">{pourcentageTourisme}%</td>
                        </tr>
                        <tr>
                            <td className="text-left"><strong>BILLETTERIE</strong></td>
                            <td className="currency-cell">{priceFormatterV3(totalCABilletterie)}</td>
                            <td className="currency-cell">{priceFormatterV3(totalDeboursBilletterie)}</td>
                            <td className="currency-cell">{priceFormatterV3(margeBilletterie)}</td>
                            <td className="percentage-cell">{pourcentageMargeBilletterie}%</td>
                            <td className="percentage-cell">{pourcentageBilletterie}%</td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr className="total-row-prof">
                            <td className="text-left"><strong>TOTAL GLOBAL</strong></td>
                            <td className="currency-cell">{priceFormatterV3(totalCAGlobal)}</td>
                            <td className="currency-cell">{priceFormatterV3(totalDeboursGlobal)}</td>
                            <td className="currency-cell">{priceFormatterV3(margeGlobale)}</td>
                            <td className="percentage-cell">{pourcentageMargeGlobale}%</td>
                            <td className="percentage-cell">100.0%</td>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </div>
    );
};

export default SyntheseActivite;
